import type { Kreuzung, KreuzenderWeg } from '../api/client';

// Klartext für OSM-Attribute. Fehlende Werte heißen „unbekannt“ – nie leer, nie geraten.

const WEGEKLASSEN: Record<string, string> = {
  motorway: 'Autobahn',
  trunk: 'Kraftfahrstraße',
  primary: 'Bundes-/Hauptstraße',
  secondary: 'Landes-/Kreisstraße',
  tertiary: 'Verbindungsstraße',
  unclassified: 'Gemeindestraße',
  residential: 'Wohnstraße',
  living_street: 'Verkehrsberuhigter Bereich',
  pedestrian: 'Fußgängerzone',
  service: 'Zufahrt',
  track: 'Wirtschaftsweg',
  footway: 'Fußweg',
  path: 'Weg',
  cycleway: 'Radweg',
  steps: 'Treppe',
};

const SERVICE_TYPEN: Record<string, string> = {
  driveway: 'Grundstückszufahrt',
  parking_aisle: 'Parkplatzweg',
  emergency_access: 'Rettungszufahrt',
  alley: 'Gasse',
};

export function wegeklasse(weg: KreuzenderWeg): string {
  const service = weg.service !== null ? SERVICE_TYPEN[weg.service] : undefined;
  const klar = service ?? WEGEKLASSEN[weg.highway] ?? 'Straße';
  const roh = weg.service !== null ? `${weg.highway}=${weg.service}` : weg.highway;
  return `${klar} (${roh})`;
}

export function tempo(weg: KreuzenderWeg): string {
  const v = weg.maxspeed;
  if (v === null) return 'Tempo unbekannt';
  if (/^\d+$/.test(v)) return `Tempo ${v}`;
  if (v === 'DE:urban') return 'Tempo innerorts (DE:urban)';
  if (v === 'DE:rural') return 'Tempo außerorts (DE:rural)';
  if (v === 'DE:zone:30' || v === 'DE:zone30') return 'Tempo-30-Zone';
  if (v === 'DE:living_street' || v === 'walk') return 'Schrittgeschwindigkeit';
  return `Tempo ${v}`;
}

export function wegZeile(weg: KreuzenderWeg): string {
  return `${weg.name ?? 'ohne Namen'} · ${wegeklasse(weg)} · ${tempo(weg)}`;
}

export function besonderheiten(k: Kreuzung): string[] {
  const out: string[] = [];
  if (k.bahnuebergang) out.push('Bahnübergang');
  if (k.ampel) out.push('Ampel');
  if (k.kreisverkehr) out.push('Kreisverkehr');
  return out;
}

export function meter(m: number): string {
  return `${Math.round(m).toLocaleString('de-DE')} m`;
}
